import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=5bd83e88&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=5bd83e88&prod&scoped=true&lang=css"
import style1 from "./rank.vue?vue&type=style&index=1&id=5bd83e88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd83e88",
  null
  
)

export default component.exports